import { render } from "./TextIconButton.vue?vue&type=template&id=096a6c6c&scoped=true"
import script from "./TextIconButton.vue?vue&type=script&lang=js"
export * from "./TextIconButton.vue?vue&type=script&lang=js"

import "./TextIconButton.vue?vue&type=style&index=0&id=096a6c6c&scoped=true&lang=css"

import exportComponent from "/var/www/abg/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-096a6c6c"]])

export default __exports__